var moduleMap = {
	"./directories": function() {
		return Promise.all(/* __federation_expose_directories */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(443), __webpack_require__.e(101), __webpack_require__.e(3192), __webpack_require__.e(7513)]).then(function() { return function() { return (__webpack_require__(7638)); }; });
	},
	"./directory-details": function() {
		return Promise.all(/* __federation_expose_directory_details */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(4108), __webpack_require__.e(5018), __webpack_require__.e(443), __webpack_require__.e(6214), __webpack_require__.e(8956), __webpack_require__.e(2698), __webpack_require__.e(101), __webpack_require__.e(7139), __webpack_require__.e(3192), __webpack_require__.e(8872), __webpack_require__.e(1222)]).then(function() { return function() { return (__webpack_require__(27901)); }; });
	},
	"./endpoint-trust": function() {
		return Promise.all(/* __federation_expose_endpoint_trust */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(443), __webpack_require__.e(101), __webpack_require__.e(5096)]).then(function() { return function() { return (__webpack_require__(93515)); }; });
	},
	"./policies": function() {
		return Promise.all(/* __federation_expose_policies */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(443), __webpack_require__.e(101), __webpack_require__.e(5122), __webpack_require__.e(5390)]).then(function() { return function() { return (__webpack_require__(53023)); }; });
	},
	"./user-devices": function() {
		return Promise.all(/* __federation_expose_user_devices */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(5979), __webpack_require__.e(7944), __webpack_require__.e(101), __webpack_require__.e(7126), __webpack_require__.e(325)]).then(function() { return function() { return (__webpack_require__(65528)); }; });
	},
	"./user-passkeys": function() {
		return Promise.all(/* __federation_expose_user_passkeys */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(5979), __webpack_require__.e(101), __webpack_require__.e(6249), __webpack_require__.e(8111)]).then(function() { return function() { return (__webpack_require__(53050)); }; });
	},
	"./user-totp": function() {
		return Promise.all(/* __federation_expose_user_totp */[__webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(5979), __webpack_require__.e(7944), __webpack_require__.e(101), __webpack_require__.e(5027)]).then(function() { return function() { return (__webpack_require__(92718)); }; });
	},
	"./user-workstations": function() {
		return Promise.all(/* __federation_expose_user_workstations */[__webpack_require__.e(8097), __webpack_require__.e(7899), __webpack_require__.e(6713), __webpack_require__.e(5979), __webpack_require__.e(101), __webpack_require__.e(4896), __webpack_require__.e(5716)]).then(function() { return function() { return (__webpack_require__(34119)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});